import { Alert, AlertColor, Box } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { Button, Container, Content, ContentBody, ContentInput, ContentInputPassword, ContentInputProfilePhoto, ContentInputProfilePhotoIcon, ContentTitle, Title } from './styles';
import { useNavigate } from 'react-router-dom';
import { UserPermissions } from '../../../App';


interface Props {
    userPermissions: UserPermissions;
}
const Users: React.FC<Props> = ({ userPermissions }) => {
    const navigate = useNavigate();

    const [username, setUsername] = React.useState<string>("");
    const [firstName, setFirstName] = React.useState("");
    const [lastName, setLastName] = React.useState("");
    const [email, setEmail] = React.useState("");

    const [birthDate, setBirthDate] = React.useState<Date>(
        new Date()
    );

    const [password, setPassword] = React.useState("");
    const [confirmPassword, setConfirmPassword] = React.useState("");


    const [logo, setLogo] = React.useState<string>("data:image/png;base64,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");
    const hiddenLogoInput = React.useRef<HTMLInputElement>(null);

    const onImageChangeClick = () => {
        if (hiddenLogoInput.current) {
            hiddenLogoInput.current.click();
        }
    };
    const onHiddenLogoInputChange = (event: any) => {
        const fileUploaded = event.target.files[0];

        var reader = new FileReader();
        var baseString;
        reader.onloadend = function () {
            baseString = reader.result;
            setLogo(baseString + '');
        };
        reader.readAsDataURL(fileUploaded);
    };

    const [showStatus, setShowStatus] = React.useState(false);
    const [statusMsg, setStatusMsg] = React.useState('');
    const [statusSeverity, setStatusSeverity] = React.useState<AlertColor>('error');
    const handleCloseStatus = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setShowStatus(false);
    };

    const onCreateUser = () => {
        if (password !== confirmPassword) {
            console.log("Not created: Password and its confirmation do not match");
            setStatusMsg(
                `User info was not updated (password and confirmation password are not the same). Please try again.`
            );
            setStatusSeverity('error');
            setShowStatus(true);
            return;
        }

        const bodyJson = {
            logo,
            username,
            email,
            firstName, lastName,
            birthDate: +birthDate,
            language: 'en-US',
            password
        };

        console.log(logo === "data:image/png;base64,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");
        console.log(bodyJson.logo);

        fetch('/api/v1/account/add', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(bodyJson)
        }).then(response => response.json()
        ).then(data => {
            console.log(data);
            if (data.success === true) {
                console.log("Created!");
                setStatusMsg('User was created! Redirecting in 5 seconds...');
                setStatusSeverity('success');
                setShowStatus(true);
                setTimeout(() => {
                    navigate(process.env.PUBLIC_URL + "/Users");
                }, 5000)
            } else {
                console.log({
                    logo,
                    username,
                    email,
                    firtName: firstName, lastName,
                    birthDate: +birthDate,
                    language: 'en-US',
                    password
                });
                console.log("Not created: ", data.reason);
                setStatusMsg(`User was not created (${data.reason + ''}). Refresh the page and try again.`);
                setStatusSeverity('error');
                setShowStatus(true);
            }
        });
    }

    return (
        <Container>
            <Title>Create User <Button onClick={() => {
                onCreateUser();
            }}>Create</Button></Title>

            <Content>
                <ContentTitle>{username} {(firstName || lastName) && `(${firstName} ${lastName})`}</ContentTitle>

                <ContentBody>
                    <ContentInput label="Username" variant="standard" onChange={(ev) => setUsername(ev.target.value)} value={username} />
                    <br />

                    <ContentInput label="First Name" variant="standard" onChange={(ev) => setFirstName(ev.target.value)} value={firstName} />
                    <br />

                    <ContentInput label="Last Name" variant="standard" onChange={(ev) => setLastName(ev.target.value)} value={lastName} />
                    <br />

                    <ContentInput label="Email" variant="standard" style={{ marginBottom: "2rem" }} onChange={(ev) => setEmail(ev.target.value)} value={email} />
                    <br />


                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            label="Custom input"
                            value={birthDate}
                            onChange={(newValue: Date | null) => {
                                setBirthDate(newValue ? newValue : new Date());
                            }}
                            renderInput={({ inputRef, inputProps, InputProps }) => (
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <input ref={inputRef} {...inputProps} style={{
                                        paddingBottom: "10px",
                                        border: "none",
                                        borderBottom: "1px solid rgba(0, 0, 0, 0.5)"
                                    }} />
                                    {InputProps?.endAdornment}
                                </Box>
                            )}
                        />
                    </LocalizationProvider>
                    <br />

                    <ContentInputPassword label="Password" onChange={(ev: any) => setPassword(ev.target.value)} style={{ marginTop: "0.5rem !important" }} />
                    <br />

                    <ContentInputPassword onChange={(ev: any) => setConfirmPassword(ev.target.value)} label="Confirm Password" />
                    <br />

                    <ContentInputProfilePhoto onClick={onImageChangeClick}>
                        {/* eslint-disable-next-line jsx-a11y/alt-text, jsx-a11y/img-redundant-alt */}
                        <img src={logo} alt="Click here to upload a profile picture" />
                        <ContentInputProfilePhotoIcon />
                        <input type="file" ref={hiddenLogoInput} onChange={onHiddenLogoInputChange} style={{ "display": "none" }} />
                    </ContentInputProfilePhoto>
                </ContentBody>
            </Content>
            {/*<div style={{ height: 500, width: '100%', paddingTop: "1rem" }}>

    </div>*/}
            <Snackbar open={showStatus} autoHideDuration={6000} onClose={handleCloseStatus}>
                <Alert onClose={handleCloseStatus} severity={statusSeverity} sx={{ width: '100%' }}>
                    {statusMsg}
                </Alert>
            </Snackbar>

        </Container>
    )
};


export default Users;